import gluteTrainingBasics from "shared/assets/marathons/glute-training-basics.png";
import osnovyLfk from "shared/assets/marathons/osnovy-lfk.svg";
import osnovyNutritsiologii from "shared/assets/marathons/osnovy-nutritsiologii.svg";
import osnovyPostroeniyaTrenirovok from "shared/assets/marathons/osnovy-postroeniya-trenirovok.svg";
import osnovyStretchinga from "shared/assets/marathons/osnovy-stretchinga.svg";
import biomechanics from "shared/assets/marathons/biomechanics.png";
import { wrapUrlWithCurrentQuery } from "common";

export const marathons = [
  {
    title: "Основы нутрициологии",
    duration: "168 минут",
    image: osnovyNutritsiologii,
    category: "Марафон",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/178"),
  },
  {
    title: "Основы ЛФК и реабилитации",
    duration: "168 минут",
    image: osnovyLfk,
    category: "Марафон",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/57"),
  },
  {
    title: "Основы биомеханики силовых упражнений",
    duration: "168 минут",
    category: "Марафон",
    image: biomechanics,
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/181"),
  },
  {
    title: "Основы построения тренировок",
    duration: "168 минут",
    category: "Марафон",
    image: osnovyPostroeniyaTrenirovok,
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/177"),
  },
  {
    title: "Основы стретчинга",
    duration: "168 минут",
    category: "Марафон",
    image: osnovyStretchinga,
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/186"),
  },
  {
    title: "Основы тренировки ягодичных мышц",
    duration: "168 минут",
    category: "Марафон",
    image: gluteTrainingBasics,
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/185"),
  },
];
